export default __webpack_public_path__ + "static/media/img58.c3aaef0b.jpg";